import React, { lazy, Suspense } from "react"

import { useCore } from "../../../hooks/useCore"
import { withAddToCart } from "./withAddToCart"

const AddToCart = withAddToCart(({ isDrop, isMobile, ...props }) => {
  const {
    helpers: { isBrowser },
  } = useCore()

  if (isMobile) {
    const AddToCartMobile = isBrowser && lazy(() => import("./AddToCartMobile"))
    return (
      AddToCartMobile && (
        <Suspense fallback={<></>}>
          <AddToCartMobile isDrop={isDrop} {...props} />
        </Suspense>
      )
    )
  } else {
    const AddToCartDesktop = isBrowser && lazy(() => import("./AddToCartDesktop"))
    return (
      AddToCartDesktop && (
        <Suspense fallback={<></>}>
          <AddToCartDesktop {...props} />
        </Suspense>
      )
    )
  }
})

export default AddToCart
